import { Paper, Group, Text, ThemeIcon, Stack } from '@mantine/core';
import type { ReactNode } from 'react';

interface StatCardProps {
  icon: ReactNode;
  value: number | string;
  label: string;
  color?: string;
  subtitle?: string;
}

export function StatCard({ icon, value, label, color = 'blue', subtitle }: StatCardProps) {
  return (
    <Paper withBorder p="md" radius="md">
      <Group>
        <ThemeIcon size={48} radius="md" variant="light" color={color}>
          {icon}
        </ThemeIcon>
        <Stack gap={2}>
          <Text size="xl" fw={700}>
            {value}
          </Text>
          <Text size="sm" c="dimmed">
            {label}
          </Text>
          {subtitle && (
            <Text size="xs" c="dimmed">
              {subtitle}
            </Text>
          )}
        </Stack>
      </Group>
    </Paper>
  );
}

/**
 * Format a number as currency (USD)
 */
export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
}
